import * as React from "react";
import { Helmet } from "react-helmet";

import { Container } from "@ui/Atoms/Grid";
import { SmallHeading } from "@ui/Atoms/Headings";
import { Section } from "@ui/Atoms/Section";
import { Paragraph } from "@ui/Atoms/Paragraph";
import { OptionPanel } from "@ui/Atoms/OptionPanel";

import { useTranslate } from "@hooks/useTranslate";

const RedirectionScreen = (): React.ReactElement => {
  const translate = useTranslate("batmaid_pwa_generic");

  return (
    <Container>
      <Helmet>
        <title>Redirecting...</title>
      </Helmet>
      <Section small>
        <OptionPanel>
          <SmallHeading>{translate("redirection_title")}</SmallHeading>
          <Paragraph>{translate("redirection_body")}</Paragraph>
        </OptionPanel>
      </Section>
    </Container>
  );
};

export { RedirectionScreen };
